import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './theme/appearance.css';
import App from './App';
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/authContext";

// Forzar formato 24H en todos los inputs de tipo time
// Esta función se ejecuta cuando el DOM está listo y cada vez que se agregan nuevos inputs
const boundTimeInputs = new WeakSet();

const bindTimeInput = (input) => {
  if (boundTimeInputs.has(input)) return;
  boundTimeInputs.add(input);
  input.setAttribute('lang', 'en-GB');
  input.setAttribute('step', '60');

  input.addEventListener('input', (e) => {
    const value = e.target.value;
    if (!value) return;
    const [hours, minutes] = value.split(':').map(Number);
    if (hours > 23) {
      e.target.value = `${String(hours % 24).padStart(2, '0')}:${String(minutes || 0).padStart(2, '0')}`;
    }
  });
};

const bindTimeInputs = (root) => {
  if (root.matches?.('input[type="time"]')) bindTimeInput(root);
  root.querySelectorAll?.('input[type="time"]').forEach(bindTimeInput);
};

document.addEventListener('DOMContentLoaded', () => bindTimeInputs(document));

// Solo los nodos nuevos. Antes se recorría todo el DOM en cada mutación
// y se volvía a registrar el mismo listener, lo que iba frenando la app.
const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === 1) bindTimeInputs(node);
    });
  }
});

// Iniciar observador cuando el documento esté listo
if (document.body) {
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

// Ignorar error benigno de ResizeObserver (común con gráficos de Material-UI)
// Este error es conocido y no afecta la funcionalidad de la aplicación
const resizeObserverErrorHandler = (e) => {
  if (
    e.message?.includes('ResizeObserver') ||
    e.message === 'ResizeObserver loop completed with undelivered notifications.'
  ) {
    e.stopImmediatePropagation();
    e.stopPropagation();
    return false;
  }
};

window.addEventListener('error', resizeObserverErrorHandler, true);

// También manejar errores no capturados
const originalErrorHandler = window.onerror;
window.onerror = function (message, source, lineno, colno, error) {
  if (
    typeof message === 'string' &&
    message.includes('ResizeObserver loop completed with undelivered notifications')
  ) {
    return true; // Suprimir el error
  }
  if (originalErrorHandler) {
    return originalErrorHandler.call(this, message, source, lineno, colno, error);
  }
  return false;
};

try {
  const onLogin = window.location.pathname.startsWith("/login");
  const hasSession = Boolean(localStorage.getItem("token"));
  const dark = localStorage.getItem("trazia-theme") === "dark";
  document.documentElement.dataset.theme = !onLogin && hasSession && dark ? "dark" : "light";
} catch {
  /* ignore */
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);